import $ from './jquery.js';
import mapStyle from './atd-map-style.js';

let locations = window.locations;
let google = window.google;

$(document).ready(function(){

    var map,
      geocoder,
      markers = [],
      infowindow,
      bounds;
      
    if(window.google) {
      geocoder = new google.maps.Geocoder(),
      infowindow = new google.maps.InfoWindow(),
      bounds = new google.maps.LatLngBounds();
    }
    
    function init() {
      // create and center our map
      map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 33.7676931, lng: -84.4906436},
        zoom: 2,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: mapStyle
      });
        
      // run through locations array
      locations.forEach(function(location, index) {
        var name = location.name,
            coords,
            url = location.url,
            addr = location.address,
            solutionType = location.solution_type,
            latLng;
        
        // create the html to populate the info window 
        var infoWindowHtml = '<h4><a href="' + url + '">' + name + '</a></h4>' + '<h5>' + solutionType + '</h5>' + location.address;
        // If we have coordinates already
        if(location.lat_long.trim().length !== 0) {
          // create an array out of our coordinate string
          coords = location.lat_long.trim().split(',');
          // convert that array to a google map compatible object
          latLng = new google.maps.LatLng(coords[0], coords[1]);
          // create marker and add event listener
          addMarker(latLng, infoWindowHtml);
        }
        else {
          // use geocoder to convert addresses to map compatible lat and lng obj
          geocoder.geocode( { 'address': addr }, function(results, status) {
            if (status == 'OK') {
              // get our google compatible obj
              latLng = results[0].geometry.location;
              // create marker and add event listener
              addMarker(latLng, infoWindowHtml);
            } else {
              console.log('Geocode was not successful for the following reason: ' + status);
            }
          });
        }
      });
      
      if(typeof initialZoom !== 'undefined') {
        if(initialZoom.lat && initialZoom.long) {
          map.setCenter(new google.maps.LatLng(initialZoom.lat, initialZoom.long));
        }

        if(initialZoom.zoom && !isNaN(parseInt(initialZoom.zoom, 10))) {
          map.setZoom(parseInt(initialZoom.zoom, 10));
        }
      }
      else {
        map.fitBounds(bounds);
      }
    }
    
    function addMarker(point, infoWindowHtml) {
      // create our marker on the map
      var marker = new google.maps.Marker({
        position: point,
        map: map,
        icon: '/wp-content/themes/voltron/dist/img/yellow-pin.png'
      });
      // add this marker to our bounds
      bounds.extend(marker.getPosition());
      // add event listener
      google.maps.event.addListener(marker, 'click', infoCallback(infoWindowHtml, marker));
      markers.push(marker);
    }
    
    function infoCallback(infoWindowHtml, marker) {
      return function() {
        // close current infowindow
        infowindow.close();
        // update the content of the infowindow before opening it
        infowindow.setContent(infoWindowHtml);
        // reopen infowindow with updated content
        infowindow.open(map, marker);
      };
    }
    
    if(document.getElementById('map')) {
      init();
    }
});
